import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrder } from './types';

export interface IOrdersPageState {
  started: boolean;
  orders?: IOrder[];
}

export const initialState: IOrdersPageState = {
  started: false,
};

export const statePropName = 'orders';

const ordersSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    startOrdersApp(state: IOrdersPageState) {
      return {
        ...initialState,
      };
    },
    updateOrders(state: IOrdersPageState, action: PayloadAction<IOrder[]>) {
      state.orders = action.payload;
    },
    ordersAppReady(state: IOrdersPageState) {
      state.started = true;
    },
  },
});

export const OrdersActions = ordersSlice.actions;
export default ordersSlice.reducer;
